// services/centralStockAPI.js
import { axiosInstance } from './api';

const BASE_URL = '/central-stock';

const centralStockAPI = {
    // ── Core CRUD ────────────────────────────────────────────────────────
    getAll: (params) => axiosInstance.get(BASE_URL, { params }),
    create: (data) => axiosInstance.post(BASE_URL, data),
    update: (id, data) => axiosInstance.put(`${BASE_URL}/${id}`, data),
    delete: (id) => axiosInstance.delete(`${BASE_URL}/${id}`),
    getById: (id) => axiosInstance.get(`${BASE_URL}/${id}`),

    // ── Transfers (now pointing to the dedicated stock-transfers routes) ─
    transfer: (data) => axiosInstance.post('/stock-transfers/central-to-branch', data),
    branchTransfer: (data) => axiosInstance.post('/stock-transfers/branch-to-branch', data),

    // ── Audit Logs ───────────────────────────────────────────────────────
    getAuditLogsForStock: (stockId, params) =>
        axiosInstance.get(`${BASE_URL}/${stockId}/audit`, { params }),

    getRecentAuditLogs: (params) =>
        axiosInstance.get(`${BASE_URL}/audit/recent`, { params }),

    // ── Filtering & Alerts ───────────────────────────────────────────────
    getCentralStockByCategory: (category, params) =>
        axiosInstance.get(`${BASE_URL}/category/${category}`, { params }),

    getLowStockItems: (params) =>
        axiosInstance.get(`${BASE_URL}/alerts/low-stock`, { params }),

    // ── Export ────────────────────────────────────────────────────────────
    export: (params = {}) => {
        const queryParams = new URLSearchParams();

        if (params.search) queryParams.append('search', params.search);
        if (params.category) queryParams.append('category', params.category);
        if (params.lowStock) queryParams.append('lowStock', 'true');
        if (params.expired) queryParams.append('expired', 'true');
        if (params.active !== undefined) queryParams.append('active', params.active);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

        return axiosInstance.get(`${BASE_URL}/export?${queryParams.toString()}`, {
            responseType: 'blob'
        });
    }
};

export default centralStockAPI;